import { Checkbox, Input, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useContext, useEffect, useState } from "react";
import { store } from "../../Helper/Context/Store";
import PostApiCall from "../../Helper/PostApi";
import Notiflix from "notiflix";

export default function Personalisation(props) {
    const { setCustomOccasion, setReceiverName,
        customText, setCustomText, receiverName,
        greetOptions, setGreetOptions,
        setOccasionId, occasionId, setSenderName, senderName, setPersonalisation } = useContext(store)

    const [showName, setShowName] = useState(true)
    useEffect(() => {
        GetCategoryAttribute();
    }, [])
    const GetCategoryAttribute = () => {
        PostApiCall.postRequest(
            {
                id: parseInt(props.variantid),
                sfor: "VariantId"
            },
            "GetCategoryAttributeValue"
        ).then((results) =>
            results.json().then((obj1) => {
                if (results.status == 200 || results.status == 201) {
                    // setAttValues(obj1.data);
                    setGreetOptions(obj1.data)
                    // setDataLoading(false);
                }
            })
        );
    };
    function toggleNameInput() {
        setShowName(!showName)
        setSenderName((prevState) => {
            if (prevState != "") {
                return ""
            }
        })
    }
    function handleChangeOccasion(value, option) {
        setCustomOccasion(option.children)
        setOccasionId(option.value)
    }


    function savePersonalization() {
        setPersonalisation(true);
        props.onCloseSelectOccasion();
    }

    function onSave() {
        if (occasionId == null) {
            Notiflix.Notify.failure("Select an occasion", { position: 'center-bottom' })
            return
        } if (receiverName == "") {
            Notiflix.Notify.failure("Receiver's name is missing", { position: 'center-bottom' })
            return
        } if (customText == "") {
            Notiflix.Notify.failure("Message is missing", { position: 'center-bottom' })
            return
        } if (showName && senderName == "") {
            Notiflix.Notify.failure("Sender's name is missing", { position: 'center-bottom' })
            return
        }
        savePersonalization()
    }
    return (
        <>
            <Select
                className="w-100"
                defaultValue={{
                    value: '',
                    label: 'Select Occasion',
                }}
                onChange={handleChangeOccasion}
            >
                {greetOptions.length ? greetOptions
                    .filter((greeting) => greeting.fld_attributename === "OCCASION")
                    .map((dat) => {
                        return (
                            <Select.Option value={dat.value}>{dat.label}</Select.Option>
                        )
                    })
                    : []}
            </Select>
            <Input onChange={(e) => setReceiverName(e.target.value)} placeholder="Dear..," className="mt-3" />
            <TextArea
                rows={4}
                className="mt-3"
                placeholder="Message"
                maxLength={55}
                onChange={(e) => setCustomText(e.target.value)}
            />
            {showName &&
                <Input
                    onChange={(e) => setSenderName(e.target.value)}
                    placeholder="From"
                    className="mt-3" />}
            <Checkbox
                className="mt-3"
                onChange={() => toggleNameInput()}>
                Don't show my name on the card
            </Checkbox>
            <div>
                <button onClick={onSave} className="theme-btn border-0 mt-3">Save</button>
            </div>
        </>
    )
}